import { Tenant, TenantInfo } from '@ivymobi/orbit-core';
import { getJSON } from '../api';

type ResetPhoneMessageArgs = [
  url: string
]
export function GetResetPhoneMessageArgs(
  props: { inv_id: string }
): ResetPhoneMessageArgs {
  const { inv_id } = props;
  if ((inv_id ?? null) === null) {
    return null;
  }
  const url = `tenants/invitations/${inv_id}/updatePhone`;
  return [url];
}

interface ResetPhoneMessage {
  inv_id: string;
  tnt_id: string;
  tenant_name: string;
  info: TenantInfo;
  old_phone: {
    countryCode: string;
    mobile: string;
  };
  new_phone: {
    countryCode: string;
    mobile: string;
  }
}
export async function GetResetPhoneMessage(
  args: ResetPhoneMessageArgs
): Promise<ResetPhoneMessage> {
  const [url] = args;
  const res = await getJSON<ResetPhoneMessage>({url});
  return res;
}